/*eslint-disable @typescript-eslint/no-explicit-any */
/*eslint-disable @typescript-eslint/no-unused-vars */
/*eslint-disable quotes */

import React, { useCallback, useEffect, useLayoutEffect, useMemo, useRef, useState } from 'react'
import { CustomBreadCrumbs, CustomButtonGroup, DashboardLoader, useAppDispatch, useAppSelector } from '../../../globalUtils/globalExports';
import { getAdvanceRuleEngineReducer, setDerivedConditionFormRedux } from '../../../rmsReduxStore/reduxExports';
import { useLocation, useNavigate } from 'react-router-dom';
import { createBreadCrumbProps } from '../../../globalUtils/globalHooks';
import { Controls, Edge, getNodesBounds, getViewportForBounds, ReactFlow, ReactFlowProvider, useEdgesState, useNodesState, useReactFlow } from '@xyflow/react';
import { DnDProvider } from './dndContext';
import DerivedConditionNode from './DerivedConditionNode';
import { Nodes } from './ExecutionPlan';
import { toast } from 'react-toastify';
import { toPng } from 'html-to-image';
import { fetchPreSignedURLForUpload } from '../../../rmsReduxStore/chargersRedux/chargerCreators';
import axios from 'axios';
import { IDerivedConditionFormRedux } from '../../../rmsReduxStore/advanceRuleEngineRedux/advanceRuleEngineType';
import { ICustomCondition } from './CustomConditionComponent';
import { isEqual } from 'lodash';


export interface IDerivedCondition {
    expression: null | string;
    conditions: ICustomCondition[]
}

const initialDerivedCondition = {
    expression: null,
    conditions: []
}

const DnDFlow: React.FC = () => {
    const dispatch = useAppDispatch();
    const navigate = useNavigate();
    const location = useLocation();
    const nodeTypes = useMemo(() => (
        {
            derivedCondition: DerivedConditionNode
        }
    ), []);
    
    const [showLoader,setShowLoader] = useState<boolean>(false);
    const [derivedCondition, setDerivedCondition] = useState<IDerivedCondition>(initialDerivedCondition);
    const initialDerivedConditionRef = useRef<IDerivedCondition | null>(initialDerivedCondition);
    const {derivedConditionFormRedux} = useAppSelector(getAdvanceRuleEngineReducer)
    const reactFlowWrapper = useRef(null);

    const handleUpdateDerivedCondition = (data: IDerivedCondition) => {
        setDerivedCondition(data);
    }

    const initialNodes: Nodes[] = [
        {
            selected: true,
            id: 'derived-condition',
            parentNodeId: '-',
            type: 'derivedCondition',
            data: {
                derivedCondition: derivedCondition,
                handleUpdateDerivedCondition: handleUpdateDerivedCondition
            },
            position: { x: 450, y: 150 }
        },
    ];

    const [nodes, setNodes, onNodesChange] = useNodesState<Nodes>(initialNodes);
    // const [edges, setEdges, onEdgesChange] = useEdgesState<Edge>([]);
    const reactFlowInstance = useReactFlow();
    const imageWidth = 1028;
    const imageHeight = 800;



    // Default React-flow function.
    const onDragOver = useCallback((event) => {
    event.preventDefault();
    event.dataTransfer.dropEffect = 'move';
    }, []);

    //To remove the react-flow watermark.
    const proOptions = { hideAttribution: true };

    // TODO
    const disableButton = useCallback(() => {
        if(isEqual(initialDerivedConditionRef?.current,derivedCondition))return true;
        if(!derivedCondition?.expression || derivedCondition?.conditions?.length === 0) return true;
        return false;
    },[derivedCondition])

    const dataURLtoBlob = (dataUrl: string): Blob => {
        const byteString = atob(dataUrl.split(',')[1]);
        const mimeString = dataUrl.split(',')[0].split(':')[1].split(';')[0];
        const arrayBuffer = new ArrayBuffer(byteString.length);
        const uintArray = new Uint8Array(arrayBuffer);

        for (let i = 0; i < byteString.length; i++) {
        uintArray[i] = byteString.charCodeAt(i);
        }

        return new Blob([uintArray], { type: mimeString });
    };

      const handleFileChange = async (file: File | null): Promise<void> => {
        if (file && file?.name) {
          const responsePreSigned = await dispatch(fetchPreSignedURLForUpload({ fileName: file?.name }));
          if (responsePreSigned && responsePreSigned.data != null) {
            const responsePut = await axios.put(responsePreSigned?.data?.url, file, {
              headers: {
                'Content-Type': file.type,
                'x-ms-blob-type': 'BlockBlob'
              }
            }
            )
            if (responsePut?.status === 201 || responsePut?.status === 200 || responsePut?.status === 202) {
              const derivedConditionForm: IDerivedConditionFormRedux = {
                id: derivedConditionFormRedux?.id ?? '',
                name: derivedConditionFormRedux?.name ?? '',
                description: derivedConditionFormRedux?.description ?? '',
                status: derivedConditionFormRedux?.status ?? '',
                derivedCondition: derivedCondition,
                fileName: responsePreSigned?.data?.blobName,
                imageURL: responsePreSigned?.data?.url
              };

              dispatch(setDerivedConditionFormRedux(derivedConditionForm));
              setShowLoader(false)
              navigate('/add-derived-condition', { state: { mode: location?.state?.mode } });
            }
    
          }
        }
      };

    const btnsList = [
        {
          buttonText: 'Save',
          buttonId: 'add',
          btnClassName: disableButton() ? 'primary__btn disabled' : 'primary__btn',
          isDisabled: disableButton(),
          handleClick: async (): Promise<any> => {
            if (disableButton()) {
              toast.error(`Derived Condition block can't be empty`);
              return
            }
            setShowLoader(true)
            reactFlowInstance.fitView({ padding: 0.1 });
            setTimeout(async () => {
              const viewportElement = document.querySelector('.react-flow__viewport');
              if (viewportElement instanceof HTMLElement) {
                  const nodeElement = document.querySelector('.react-flow__node') as HTMLElement;
                  if (!nodeElement) return;
                  const nodeRect = nodeElement.getBoundingClientRect();

                  // nodeRect gives screen pixels, we need to convert to flow coordinates
                  // by dividing by the current viewport zoom
                  const currentViewport = reactFlowInstance.getViewport();

                  const zoom = currentViewport.zoom;

                  // True node dimensions in flow coordinate space
                  const nodeWidth = nodeRect.width / zoom;
                  const nodeHeight = nodeRect.height / zoom;

                  const nodes = reactFlowInstance.getNodes();
                  const nodeX = nodes[0].position.x;
                  const nodeY = nodes[0].position.y;

                  const padding = 60;
                  const zoomX = (imageWidth - padding * 2) / nodeWidth;
                  const zoomY = (imageHeight - padding * 2) / nodeHeight;
                  const fitZoom = Math.min(zoomX, zoomY, 2);

                  const scaledWidth = nodeWidth * fitZoom;
                  const scaledHeight = nodeHeight * fitZoom;

                  const translateX = (imageWidth - scaledWidth) / 2 - nodeX * fitZoom;
                  const translateY = (imageHeight - scaledHeight) / 2 - nodeY * fitZoom;

                  const dataUrl = await toPng(viewportElement, {
                    backgroundColor: '#FAFAFA',
                    width: imageWidth,
                    height: imageHeight,
                    style: {
                      width: `${imageWidth}px`,
                      height: `${imageHeight}px`,
                      transform: `translate(${translateX}px, ${translateY}px) scale(${fitZoom})`,
                      transformOrigin: 'top left',
                    },
                  });
    
    
                // Convert dataUrl to Blob
                const blob = dataURLtoBlob(dataUrl);
    
                const file = new File([blob], 'canvasImage.png', { type: 'image/png' });
    
                // API call to upload the file
                handleFileChange(file)
              } else {
                console.error('Viewport element not found.');
              }
            }, 100); // Adjust delay as needed
          },
          buttonVariant: 'filled',
    
        },
        {
          buttonText: 'Cancel',
          buttonId: 'cancel',
          btnClassName: 'secondary__btn',
          handleClick: (): void => {
            navigate('/add-derived-condition', { state: { mode: location?.state?.mode } });
          },
          isDisabled: false,
          buttonVariant: 'outlined',
        }
      ]

    useEffect(()=>{
        const updatedNode = {
            selected: true,
            id: 'derived-condition',
            parentNodeId: '-',
            type: 'derivedCondition',
            data: {
                derivedCondition: derivedCondition,
                handleUpdateDerivedCondition: handleUpdateDerivedCondition
            },
            position: { x: 450, y: 150 }
        }
        setNodes([updatedNode]);
    },[derivedCondition])

    useLayoutEffect(()=>{
        setDerivedCondition(derivedConditionFormRedux?.derivedCondition);
        initialDerivedConditionRef.current = derivedConditionFormRedux?.derivedCondition
    },[])


    return (
    <>
      <DashboardLoader showLoader={showLoader} />
      <div className='advance_rule_engine_dndflow'>
        <div className="reactflow-wrapper" ref={reactFlowWrapper}>
          <ReactFlow
            nodes={nodes}
            nodeTypes={nodeTypes}
            onDragOver={onDragOver}
            proOptions={proOptions}
            nodesDraggable={false}
            panOnDrag={true}
            elementsSelectable={true}
            deleteKeyCode={null}
            minZoom={0.05}
          >
            <Controls style={{ marginBottom: '40px' }} />
          </ReactFlow>

          <div className='rule__engine__canvas__footer'>
            <CustomButtonGroup
              buttonsList={btnsList}
              buttonGroupClassName='button__group__footer'
            />
          </div>
        </div>
      </div>
    </>
    )
}

const DerivedConditionPlan: React.FC = () => {
  const { derivedConditionFormRedux } = useAppSelector(getAdvanceRuleEngineReducer);
  const location = useLocation();
  const breadCrumbs = useMemo(() => createBreadCrumbProps({
    breadCrumbProps:
      [
        {
          objectType: 'link',
          id: 'newDerivedCondition',
          linkBtnState: { mode: location?.state?.mode }
        },
        {
          objectType: 'text',
          id: 'text',
          text: 'Define Execution Plan'
        },
        {
          objectType: 'text',
          id: 'text',
          text: derivedConditionFormRedux?.name
        },

      ]
  }), [derivedConditionFormRedux])
  return (
    <>
      <ReactFlowProvider>
        <DnDProvider>
          <div style={{ height: '100%', width: '100%', display: 'flex', flexDirection: 'column' }}>
            <CustomBreadCrumbs breadCrumbs={breadCrumbs} customRuleEngine={true} />
            <DnDFlow />
          </div>
        </DnDProvider>
      </ReactFlowProvider>
    </>
  )
}

export default DerivedConditionPlan